
































































import { computed } from '@nuxtjs/composition-api';
import { defineComponent } from '@vue/composition-api';
import { useCartAttributes } from '~/features/cart';
import { useGiftTiers, useNextLevelAmount } from '~/features/gift-tiers';

export default defineComponent({
  setup() {
    const { cartPromotions, subtotalWithDiscounts } = useCartAttributes();

    const lastTierGiftName = computed(() => {
      const lastTier = cartPromotions.value?.options?.[cartPromotions.value?.options?.length - 1];

      if (Array.isArray(lastTier?.gift)) {
        return lastTier?.gift[0]?.name;
      }

      return lastTier?.gift?.name;
    });

    const { nextLevelAmount } = useNextLevelAmount(cartPromotions);

    const { amountRemaining, currentTier, progressDone } = useGiftTiers(
      nextLevelAmount,
      subtotalWithDiscounts,
      computed(() => ({
        tiers:
          cartPromotions.value?.options?.map(option => ({
            discountValue: option?.tier_minimum_subtotal || 0,
          })) || [],
        eligibleTierIdx: cartPromotions.value.eligiblePromotionIdx,
      }))
    );

    return {
      progressDone,
      cartPromotions,
      nextLevelAmount,
      amountRemaining,
      currentTier,
      lastTierGiftName,
    };
  },
});
